import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import AccountingWebAPIUtils from 'utils/AccountingWebAPIUtils';
import SessionStore from 'stores/SessionStore';
import CargomaticInput from 'components/v2/input';
import Button from 'components/v2/buttons/Button';
import { titleize } from 'underscore.string';

function onSelect(_value, item, history) {
  if (item && item._id) {
    history.push(`/invoices/${item._id}`, { id: item._id });
  }
}

async function searchForAdmin(invoiceNumbers) {
  const {
    entity: { invoices },
  } = await AccountingWebAPIUtils.getInvoicesByNumber({
    number: invoiceNumbers,
  });

  return invoices;
}

async function searchForShipper(invoiceNumbers) {
  const {
    entity: { invoices },
  } = await AccountingWebAPIUtils.getInvoicesByNumberShipper(
    SessionStore.getUser()._id,
    { number: invoiceNumbers },
  );

  return invoices;
}

class InvoiceSearch extends Component {
  static propTypes = {
    onSelect: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      referenceNumbers: '',
    };
  }

  async search() {
    try {
      const onSelection = this.props.onSelect || onSelect;
      let { referenceNumbers = '' } = this.state;
      referenceNumbers = referenceNumbers?.trim()?.toUpperCase();
      const invoiceNumber = referenceNumbers
        ?.split(',')
        .map((item) => item?.trim());
      const invoices = SessionStore.isShipper()
        ? await searchForShipper(invoiceNumber)
        : await searchForAdmin(invoiceNumber);

      this.setState({ items: invoices, referenceNumbers: '' });
      onSelection(invoices);
    } catch (e) {
      console.error(e);
    }
  }

  handleSearch = (input) => {
    this.setState((prev) => ({
      ...prev,
      referenceNumbers: input,
    }));
  };

  render() {
    const { t } = this.props;

    return (
      <div className="flex items-center justify-between gap-2">
        <CargomaticInput
          className="block form-label w-full"
          inputClassNames="w-full form-field"
          type="text"
          placeholder={t('SEARCH_FOR_REFERENCE')}
          hideLabel
          onChange={this.handleSearch}
          value={this.state.referenceNumbers}
        />
        <Button
          color="green"
          onClick={() => this.search()}
          disabled={!this.state.referenceNumbers.length}
        >
          {titleize(t('ADD'))}
        </Button>
      </div>
    );
  }
}

InvoiceSearch.propTypes = {
  history: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default withRouter(withTranslation()(InvoiceSearch));
